import { I18nComponente } from "@/types/gerais"

export const ODadosResponsabilidadeUsuarioi18n: I18nComponente = {
  "pt-BR": {
    emailDeAcesso: "e-mail de acesso",
    novaSenha: "nova senha",
    perfilDePermissaoNaOrganizacao: "perfil de permissão na organização",
    Administrador: "Administrador",
    Supervisor: "Supervisor",
    gerente: "Gerente",

    Pessoal: "Pessoal",
    Visualizador: "Visualizador",
    descricaoAdministrador: "acesso máximo a todas as funções do sistema",
    descricaoSupervisor: "acesso apenas aos projetos e grupos pelos quais é responsável",
    descricaoGerente: "acesso aos projetos e grupos pelos quais é responsável",

    descricaoPessoal: "acesso apenas às próprias informações e calendário de atividades",
    descricaoVisualizador: "acesso apenas à visualização de projetos e grupos pelos quais é responsável",
  },
  "es-CO": {
    emailDeAcesso: "corréo de acceso",
    novaSenha: "nueva contraseña",
    perfilDePermissaoNaOrganizacao: "perfil de permisos en la organización",
    administrador: "administrador",
    supervisor: "supervisor",
    gerente: "gerente",

    pessoal: "personal",
    visualizador: "visualizador",
    descricaoAdministrador: "acceso máximo a todas las funcionalidades del sistema",
    descricaoSupervisor: "acceso solo a los proyectos o grupos de los quales el usuario es responsable",
    descricaoGerente: "acceso a los proyectos y grupos de los cuales el usuario es responsable",

    descricaoPessoal: "acceso al calendario personal de actividades",
    descricaoVisualizador: "acceso solo a la visualización o grupos de los quales el usuario es responsable, no manipula información en el sistema",
  }
}
